import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { IPrivateRequestAcceptRequest } from "./request.types";
import type { TGetPrivateRequestResponse } from "./response.types";

class PrivateRequestController extends Controller {
	public constructor() {
		super({ requestUrl: "models/privateRequests/" });
	}

	/**@GET PRIVATE REQUEST */
	public async getPrivateRequestAsync({ token }: IRequestConfig) {
		return this.get<TGetPrivateRequestResponse[]>("base", "", { token });
	}

	/**@POST PRIVATE CHAT ACCEPT */
	public async privateRequestAcceptAsync({ token, userId }: IPrivateRequestAcceptRequest) {
		return this.post<void>(`${userId}/accept`, null, { token });
	}

	/**@DELETE PRIVATE CHAT DECLINE */
	public async privateRequestDeclineAsync({ token, userId }: IPrivateRequestAcceptRequest) {
		return this.delete<void>(`${userId}`, { token });
	}
}

export const privateRequestAPI = new PrivateRequestController();
